// Extend Impact without editing its generated sections.js asset.
(() => {
  if (!window.customElements) return;
  customElements.whenDefined('image-banner').then(() => {
    if (customElements.get('collection-image-banner')) return;
    const ImageBanner = customElements.get('image-banner');
    class CollectionImageBanner extends ImageBanner {
      get parallax() {
        // Native touch scrolling must not compete with a JS-driven scroll animation.
        if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return false;
        return super.parallax;
      }
    }
    customElements.define('collection-image-banner', CollectionImageBanner);
  });
})();
